import { g as h } from "./index767.mjs";
import { s as k } from "./index847.mjs";
import { f as B } from "./index816.mjs";
import { t as O } from "./index781.mjs";
import { q as S } from "./index785.mjs";
import { e as g } from "./index846.mjs";
import { e as x } from "./index848.mjs";
import { e as E } from "./index849.mjs";
import { e as T } from "./index772.mjs";
var t = h, W = k, u = B, s = O.set, w = S, M = g, P = x, N = E, m = T, I = t.MutationObserver || t.WebKitMutationObserver, p = t.document, b = t.process, o = t.Promise, c = W("queueMicrotask"), r, v, f, a, l;
if (!c) {
  var i = new w(), n = function() {
    var e, d;
    for (m && (e = b.domain) && e.exit(); d = i.get(); )
      try {
        d();
      } catch (_) {
        throw i.head && r(), _;
      }
    e && e.enter();
  };
  !M && !m && !N && I && p ? (v = !0, f = p.createTextNode(""), new I(n).observe(f, { characterData: !0 }), r = function() {
    f.data = v = !v;
  }) : !P && o && o.resolve ? (a = o.resolve(void 0), a.constructor = o, l = u(a.then, a), r = function() {
    l(n);
  }) : m ? r = function() {
    b.nextTick(n);
  } : (s = u(s, t), r = function() {
    s(n);
  }), c = function(e) {
    i.head || r(), i.add(e);
  };
}
var q = c;
export {
  q as m
};
